// extracted by mini-css-extract-plugin
export default {"component":"result-summary__lmS2b"};